import { api, authApi } from '@xstudios/xapp-auth/services/authService'

export async function convertWorkspaceProject(payload) {
  const { data } = await api.post('google-workspace/projects/convert', payload)
  return data
}

export async function createWorkspaceClient(name) {
  const { data } = await api.post('google-workspace/clients', { name })
  return data
}

export async function createWorkspaceConvertJob(payload) {
  const { data } = await api.post(
    'google-workspace/projects/convert/jobs',
    payload
  )
  return data
}

export async function createWorkspaceProposal(payload) {
  const { data } = await api.post('google-workspace/proposals', payload)
  return data
}

export async function createWorkspaceProposalJob(payload) {
  const { data } = await api.post('google-workspace/proposals/jobs', payload)
  return data
}

export async function deleteWorkspaceProject(projectFolderId) {
  const { data } = await api.delete(
    `google-workspace/projects/${encodeURIComponent(projectFolderId)}`
  )
  return data
}

export async function disconnectWorkspace() {
  const { data } = await authApi.post('/google-workspace/disconnect')
  return data
}

export async function getWorkspaceClientProjects(clientFolderId) {
  const { data } = await api.get(
    `google-workspace/clients/${encodeURIComponent(clientFolderId)}/projects`
  )
  return Array.isArray(data) ? data : []
}

// ----------------------------------------------------------------------------
// Clients, Services, Quote Sheets, and Projects
// ----------------------------------------------------------------------------
export async function getWorkspaceClients() {
  const { data } = await api.get('google-workspace/clients')
  return Array.isArray(data) ? data : []
}

export async function getWorkspaceConnectUrl(returnTo = '/project-starter') {
  const { data } = await authApi.get('/google-workspace/connect', {
    params: {
      return_to: returnTo,
    },
  })
  return data?.auth_url || ''
}

export async function getWorkspaceProjectTemplates() {
  const { data } = await api.get('google-workspace/project-templates')
  return Array.isArray(data?.items) ? data.items : []
}

export async function getWorkspaceQuoteSheets() {
  const { data } = await api.get('google-workspace/quote-sheets')
  return Array.isArray(data?.items) ? data.items : []
}

export async function getWorkspaceServices() {
  const { data } = await api.get('google-workspace/services')
  return Array.isArray(data?.items) ? data.items : []
}

export async function getWorkspaceSlackChannelMembers({
  clientName,
  projectName,
}) {
  const { data } = await api.get('google-workspace/slack-channel-members', {
    params: {
      client_name: clientName,
      project_name: projectName,
    },
  })
  return data || {}
}

// ----------------------------------------------------------------------------
// Authentication & Connection
// ----------------------------------------------------------------------------
export async function getWorkspaceStatus() {
  const { data } = await authApi.get('/google-workspace/status')
  return data
}

export async function getWorkspaceUsers(search = '') {
  const { data } = await api.get('google-workspace/users', {
    params: { search },
  })
  return Array.isArray(data?.items) ? data.items : []
}
